import { Box } from "@mui/material";
import { useCallback, useState } from "react";
import AppPage from "../../../components/structure/AppPage";
import ConfigurationFileSection from "./ConfigurationFileSection";
import ContainerImageSection from "./ContainerImageSection";
import DebugUtilsSection from "./DebugUtilsSection";
import InstallationGuideSection from "./InstallationGuideSection";

export default function OnPremConfigurationView() {
  const [selectedConfigVersion, setSelectedConfigVersion] = useState("");
  const handleSelectConfigVersion = useCallback((version) => {
    setSelectedConfigVersion(version);
  }, []);

  return (
    <AppPage title="On-Prem Connector">
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 2,
        }}
      >
        <ContainerImageSection />

        <ConfigurationFileSection
          selectedVersion={selectedConfigVersion}
          onChangeVersion={handleSelectConfigVersion}
        />

        <InstallationGuideSection selectedVersion={selectedConfigVersion} />

        <DebugUtilsSection />
      </Box>
    </AppPage>
  );
}
